import router from '@/router'
import DataRetentionPage from './views/DataRetention.vue'

router.addRoute({
  path: '/data-retention',
  name: 'DataRetentionPage',
  component: DataRetentionPage,
  meta: {
    layout: 'dashboard'
  }
})
